(function () {
  const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');

  function getPurchaseElements(picker) {
    if (!picker) return {};
    const sectionId = picker.dataset.section;
    if (!sectionId) return {};
    const form = document.getElementById('product-form-' + sectionId);
    const input = form && form.querySelector('input[name="id"]');
    const button = form && form.querySelector('[type="submit"][name="add"]');
    return { form, input, button };
  }

  function syncVariantPurchaseState(picker) {
    if (!picker || !picker.currentVariant) return;
    const variant = picker.currentVariant;
    const { input, button } = getPurchaseElements(picker);
    if (input) { input.value = variant.id; input.disabled = false; }
    if (button) {
      const available = variant.available !== false;
      button.disabled = !available;
      if (available) {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        const spinner = button.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.add('hidden');
      } else button.setAttribute('aria-disabled', 'true');
    }
  }

  function patchVariantEngine() {
    const Base = customElements.get('variant-selects');
    if (!Base) return;
    if (!Base.prototype.__td3PreviewRequestPatch) {
      Base.prototype.__td3PreviewRequestPatch = true;
      const originalCreateRequestUrl = Base.prototype.createRequestUrl;
      Base.prototype.createRequestUrl = function (args) {
        const raw = originalCreateRequestUrl ? originalCreateRequestUrl.call(this, args) : null;
        if (!raw || !previewThemeId) return raw;
        try {
          const url = new URL(raw, window.location.origin);
          url.searchParams.set('preview_theme_id', previewThemeId);
          return url.pathname + url.search;
        } catch (e) { return raw; }
      };
    }
    if (!Base.prototype.__td3VariantPurchaseSyncPatch) {
      Base.prototype.__td3VariantPurchaseSyncPatch = true;
      const originalOnVariantChange = Base.prototype.onVariantChange;
      Base.prototype.onVariantChange = function () {
        const result = originalOnVariantChange.apply(this, arguments);
        const picker = this;
        setTimeout(function () { syncVariantPurchaseState(picker); }, 0);
        setTimeout(function () { syncVariantPurchaseState(picker); }, 120);
        return result;
      };
    }
  }

  function refreshProductSliders() {
    document.querySelectorAll('.product-section .js-media-list, .product-section .js-media-sublist').forEach(function (element) {
      try { if (element.swiper && !element.swiper.destroyed) element.swiper.update(); } catch (e) {}
    });
  }

  function getFirstVisibleThumb(productSection) {
    const subSlider = productSection.querySelector('.js-media-sublist');
    if (!subSlider) return null;
    const thumbs = Array.from(subSlider.querySelectorAll('[data-media-sub-id]'));
    return thumbs.find(function (thumb) {
      const style = window.getComputedStyle(thumb);
      return style.display !== 'none' && style.visibility !== 'hidden' && !thumb.hidden;
    }) || null;
  }

  function selectInitialProductImage(productSection) {
    if (!productSection || productSection.dataset.td3CustomerChangedVariant === 'true') return false;

    const subSlider = productSection.querySelector('.js-media-sublist');
    const mainSlider = productSection.querySelector('.js-media-list');
    const firstThumb = getFirstVisibleThumb(productSection);
    if (!subSlider || !mainSlider || !firstThumb) return false;

    const mediaSubId = firstThumb.getAttribute('data-media-sub-id');
    if (!mediaSubId) return false;

    const target = mainSlider.querySelector('[data-media-id="' + CSS.escape(mediaSubId) + '"]');
    if (!target) return false;

    const mainSwiper = mainSlider.swiper;
    if (!mainSwiper || mainSwiper.destroyed) return false;

    try {
      mainSwiper.update();
      const targetIndex = Array.from(mainSwiper.slides).indexOf(target);
      if (targetIndex < 0) return false;
      mainSwiper.slideTo(targetIndex, 0, false);

      if (subSlider.swiper && !subSlider.swiper.destroyed) {
        subSlider.swiper.update();
        const thumbIndex = Array.from(subSlider.swiper.slides).indexOf(firstThumb);
        if (thumbIndex >= 0) subSlider.swiper.slideTo(thumbIndex, 0, false);
      }

      productSection.dataset.td3InitialProductImageSelected = 'true';
      return true;
    } catch (e) {
      return false;
    }
  }

  function scheduleInitialMainImageFix() {
    [80, 180, 350, 700, 1200, 2000].forEach(function (delay) {
      setTimeout(function () {
        document.querySelectorAll('.product-section').forEach(function (section) {
          if (section.dataset.td3CustomerChangedVariant !== 'true') selectInitialProductImage(section);
        });
      }, delay);
    });
  }

  function activateThumbnailClickFix() {
    if (document.documentElement.dataset.td3ThumbnailClickFix === 'true') return;
    document.documentElement.dataset.td3ThumbnailClickFix = 'true';
    document.addEventListener('click', function (event) {
      const thumb = event.target && event.target.closest ? event.target.closest('.product-section .js-media-sublist [data-media-sub-id]') : null;
      if (!thumb) return;
      const subSlider = thumb.closest('.js-media-sublist');
      const productSection = thumb.closest('.product-section');
      const mainSlider = productSection && productSection.querySelector('.js-media-list');
      if (!subSlider || !mainSlider || !mainSlider.swiper || mainSlider.swiper.destroyed) return;
      const mediaSubId = thumb.getAttribute('data-media-sub-id');
      if (!mediaSubId) return;
      const target = mainSlider.querySelector('[data-media-id="' + CSS.escape(mediaSubId) + '"]');
      let targetIndex = target ? Array.from(mainSlider.swiper.slides).indexOf(target) : -1;
      if (targetIndex < 0) targetIndex = Array.from(subSlider.querySelectorAll('[data-media-sub-id]')).indexOf(thumb);
      if (targetIndex < 0) return;
      event.preventDefault();
      mainSlider.swiper.slideTo(targetIndex);
      try { if (subSlider.swiper && !subSlider.swiper.destroyed) subSlider.swiper.slideTo(targetIndex); } catch (e) {}
    }, true);
  }

  customElements.whenDefined('variant-selects').then(patchVariantEngine);
  activateThumbnailClickFix();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleInitialMainImageFix, { once: true });
  else scheduleInitialMainImageFix();

  document.addEventListener('change', function (event) {
    const picker = event.target && event.target.closest ? event.target.closest('variant-radios, variant-selects') : null;
    if (!picker) return;
    const productSection = picker.closest('.product-section');
    if (productSection) productSection.dataset.td3CustomerChangedVariant = 'true';
    setTimeout(function () { syncVariantPurchaseState(picker); }, 0);
    setTimeout(function () { syncVariantPurchaseState(picker); }, 120);
  });

  document.addEventListener('variant:change', function (event) {
    const sectionId = event.detail && event.detail.sectionId;
    const picker = sectionId ? document.querySelector('variant-radios[data-section="' + sectionId + '"], variant-selects[data-section="' + sectionId + '"]') : null;
    if (picker) syncVariantPurchaseState(picker);
    setTimeout(refreshProductSliders, 50);
    setTimeout(refreshProductSliders, 250);
  });

  document.addEventListener('shopify:section:load', function () {
    patchVariantEngine();
    activateThumbnailClickFix();
    setTimeout(refreshProductSliders, 50);
    scheduleInitialMainImageFix();
  });
})();